<template>
  <div>
    <v-data-table :key="updater" :headers="headers" :items="athletes" sort-by="Id" class="elevation-1">
      <!-- Associate athletes in top datatable -->
      <template v-slot:top>
        <v-toolbar flat color="white">
          <v-spacer></v-spacer>

          <!-- Add athletes dialog -->
          <v-dialog v-model="dialog" fullscreen v-if="canManageCurrentTeam">
            <template v-slot:activator="{ on }">
              <v-btn color="primary" dark class="mb-2" v-on="on" @click="openAssociateUserDialog">Associer athlètes</v-btn>
            </template>
            <!--Partie de saisie du dialog-->
            <v-card>
              <v-card-text>
                <v-container>
                  <v-col cols="12" sm="6" md="12">
                    <v-select
                      v-model="usersToAssociate"
                      label="Utilisateurs à associer"
                      :items="usersNotInTeam"
                      item-text="email"
                      item-value="id"
                      attach
                      chips
                      multiple
                      return-object
                      clearable
                      style="min-width: 200px"
                    ></v-select>
                  </v-col>
                </v-container>
              </v-card-text>
              <!--Fin du dialog-->
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="closeDialog()">Annuler</v-btn>
                <v-btn color="blue darken-1" text @click="associateUserToTeam(usersToAssociate)">Associer</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-toolbar>
      </template>
      <!-- Actions on discipline -->
      <template v-slot:[`item.actions`]="{ item }">
        <v-icon @click="removeUserFromTeam(item.id)" v-if="canManageCurrentTeam">mdi-power-plug-off</v-icon>
      </template>
    </v-data-table>
  </div>
</template>
<script>
import { getTeamAsync, affectUsersToTeamAsync, removeUserFromTeamAsync, getUsersNotInTeamAsync, getTeamUsersAsync, getIsUserPartOfTeamAsync } from "../../api/teamApi";
import { getIsUserPartOfFederationAsync } from "@/api/federationsApi";
import { getIsManagerPartOfDisciplineAsync, getIsCoachPartOfDisciplineAsync } from "@/api/disciplinesApi";
import store from "@/store";
import { VDataTable } from "vuetify/lib";
import PermissionsService from "@/services/PermissionsService";
import AuthService from "@/services/AuthService";

export default {
  components: {
    VDataTable,
  },

  props: {
    teamId_prop: [Number, String],
  },

  watch: {
    dialog(val) {
      val || this.closeDialog();
    },
    $route() {
      this.initPage();
    },
  },

  data: () => ({
    federationId: null,
    disciplineId: null,
    coachId: null,
    teamId: null,
    isCurrentUserPartOfFederation: false,
    isCurrentUserManagerOfDiscipline: false,
    isCurrentUserCoachOfDiscipline: false,
    isCurrentUserCoachOfTeam: false,
    isCurrentUserPartOfTeam: false,
    authService: AuthService,
    dialog: false,
    headers: [
      { text: "Id", value: "id", sortable: true },
      { text: "Email", value: "email", sortable: true },
      { text: "Prénom", value: "firstName", sortable: true },
      { text: "Nom", value: "lastName", sortable: true },
      { text: "Actions", value: "actions", sortable: false },
    ],
    usersToAssociate: [],
    federation: {},
    discipline: {},
    coach: {},
    team: {},
    athletes: [],
    editedIndex: -1,
    editedItem: {},
    usersNotInTeam: [],
    updater: 0,
  }),

  computed: {
    canViewCurrentTeam() {
      // Can view own Team and is part of current Team
      let canViewOwnTeamAndIsPartOfCurrentTeam = PermissionsService.TeamsPermissionsService.canViewOwnTeam && this.isCurrentUserPartOfTeam;
      // Can view all Teams and is part of discipline (coach or manager) or part of federation
      let canViewAllTeams =
        PermissionsService.TeamsPermissionsService.canViewAllTeamsOwnDiscipline &&
        (this.isCurrentUserManagerOfDiscipline || this.isCurrentUserCoachOfDiscipline || this.isCurrentUserPartOfFederation);
      return canViewOwnTeamAndIsPartOfCurrentTeam || canViewAllTeams;
    },
    canManageCurrentTeam() {
      // Can manage own Team and is coach of current Team
      let canManageCurrentTeamAndIsPartOfCurrentTeam = PermissionsService.TeamsPermissionsService.canManageOwnTeam && this.isCurrentUserCoachOfDiscipline;
      // Can manage all Teams and is part of discipline (coach or manager) or part of federation
      let canManageAllTeams =
        PermissionsService.TeamsPermissionsService.canManageAllTeamsOwnDiscipline &&
        (this.isCurrentUserManagerOfDiscipline || this.isCurrentUserCoachOfDiscipline || this.isCurrentUserPartOfFederation);
      return canManageCurrentTeamAndIsPartOfCurrentTeam || canManageAllTeams;
    },
  },

  async mounted() {
    await this.initPage();
  },

  methods: {
    async initPage() {
      // Override the props values from the url if provided
      this.federationId = this.$route.params.federationId ? parseInt(this.$route.params.federationId) : this.federationId_prop;
      this.disciplineId = this.$route.params.disciplineId ? parseInt(this.$route.params.disciplineId) : this.disciplineId_prop;
      this.coachId = this.$route.params.coachId ? this.$route.params.coachId : this.coachId_prop;
      this.teamId = this.$route.params.teamId ? parseInt(this.$route.params.teamId) : this.teamId_prop;

      // Check if the current user is part of current federation
      this.isCurrentUserPartOfFederation = await getIsUserPartOfFederationAsync(this.authService.userId, this.federationId);
      // Check if the current user is part of current discipline
      this.isCurrentUserCoachOfDiscipline = await getIsCoachPartOfDisciplineAsync(this.authService.userId, this.disciplineId);
      // Check if the current user is part of current discipline
      this.isCurrentUserManagerOfDiscipline = await getIsManagerPartOfDisciplineAsync(this.authService.userId, this.disciplineId);
      // Check if the current user is part of current team
      this.isCurrentUserPartOfTeam = await getIsUserPartOfTeamAsync(this.authService.userId, this.teamId);

      // Check if the user can see this page
      if (!this.canViewCurrentTeam) {
        store.dispatch("setSnackbar", {
          title: `Non Autorisé`,
          text: `Vous n'êtes pas autorisé à consulter cette ressource.`,
          status: "warning",
          timeout: 2000,
        });

        this.$router.replace("/");
      }

      this.team = await getTeamAsync(this.teamId);
      // this.coach = await getUserAsync(this.coachId);
      // this.discipline = await getDisciplineAsync(this.disciplineId);
      // this.federation = await getFederationByIdAsync(this.discipline.parentFederationId);

      this.initializeList();
    },

    // Get the athletes and the list of users not in team
    async initializeList() {
      // get the list of all users in order to provide it to the list of available user to add in the discipline
      this.usersNotInTeam = await getUsersNotInTeamAsync(this.teamId);

      // Build the datatable values from the prop
      this.athletes = await getTeamUsersAsync(this.teamId);
    },

    // Associate a user to the team
    async associateUserToTeam() {
      var usersToAssociateIds = this.usersToAssociate.map((u) => u.id);

      var result = await affectUsersToTeamAsync(this.teamId, usersToAssociateIds);

      if (result) {
        store.dispatch("setSnackbar", {
          title: "Utilisateur(s) associé(s)",
          text: "Les utilisateurs ont bien été associés à l'équipe.",
          status: "success",
          timeout: 2000,
        });
      }

      this.closeDialog();

      await this.initializeList();
    },

    // Remove the association between the team and the user
    async removeUserFromTeam(userId) {
      if (confirm("Etes-vous sûr de vouloir retirer cet utilisateur de l'équipe ?")) {
        var result = await removeUserFromTeamAsync(this.teamId, userId);

        if (result) {
          store.dispatch("setSnackbar", {
            title: "Utilisateur retiré",
            text: "L'utilisateur a bien été retiré de l'équipe.",
            status: "success",
            timeout: 2000,
          });
        }

        await this.initializeList();
      }
    },

    // Open the associate user dialog
    openAssociateUserDialog() {
      this.dialog = true;
    },

    // Close the associate user dialog
    closeDialog() {
      this.dialog = false;
      this.usersToAssociate = [];
    },
  },
};
</script>
